// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Overlay_overlay__5a2zu","backdrop":"Overlay_backdrop__F12DQ","background":"Overlay_background__hnUie"};